export { default as AxisGQL } from './axis-gql'
